export default function FullScreenLoader({ message }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-glyco-purple"></div>
        <p className="mt-4 text-gray-600">{message || 'Loading...'}</p>
      </div>
    </div>
  )
}